/* eslint-disable max-len */
/* Source: loyaltyperks12@yopmail.com in PROD */
/* As of 2024Q2: VIP user with Gold Paint, Unclaimed perks, Available perks, Available Offers, and zero Challenges */
import { getFormattedDaysFromToday } from '../../common/utils/DrawerUtils';

export default {
  customerAccountId: '04261DFAD0A3DFA10S',
  currentTierId: '35c8d2a6-28ff-40c4-b34e-b950f7ef4e66',
  nextTierId: '1709a6d5-22cd-4526-b0e0-dd523702fcb5',
  currentYearSpend: 65,
  perkCounter: 7,
  recentlyAdded: false,
  programMembershipStartDate: '05/18/2023',
  activePxccFactor: 4,
  pxccUserCategory: 'Enrolled',
  accrualData: [
    {
      year: 2024,
      currentYear: true,
      accrual: 65,
      acceleratedAccrual: 65,
      pxccAccrual: 0,
      pxccAcceleratedAccrual: 0,
      nonPxccAccrual: 65,
      spendForNextPerk: 599935,
      spendForNextPerkWithPxcc: 149984,
      spendForFutureTierPerk: 699935,
      spendForFutureTierPerkWithPxcc: 174984,
      finalTierPerkAchieved: false
    }
  ],
  program: {
    name: 'Pro Xtra Perks',
    description: 'This program represents the Pro Xtra Perks Program that will be used in production for National Launch',
    programId: '9d784dbe-0a31-40ea-ba06-497e0333f3be',
    type: 'Loyalty',
    startDate: '2020-01-01T00:00:00Z',
    tiers: [
      {
        tierId: 'f0b47339-c205-4117-aa42-aee127834001',
        name: '0-2.5K',
        tierNumber: 5090,
        minThreshold: 0,
        maxThreshold: 2500,
        minThresholdDisplay: '0',
        maxThresholdDisplay: '2.5K',
        earned: true,
        tierPerks: [
          {
            perkId: 'f8b0e2d0-8d90-4515-a740-dbabd57e5b32',
            perkTitle: '$30 Perk ExxonMobil',
            perkDescription: 'By selecting this Perk, you will receive an extra $5 Bonus Coupon to use at Home Depot. Scan the above barcode to redeem at Home Depot. Do not scan barcode at Exxon or Mobil stations.\n\n\n3,000 Exxon Mobil Rewards+ points — a $30 value for fuel and more. Redeem this Perk when you make a fuel purchase at participating Exxon and Mobil service stations. \n\n**After Perk Selection**\n* You will receive an email with a unique Promo Code and a [link to instructions](http://www.homedepot.com/c/exxonmobil-perk) on how to redeem your Perk\n* You must create an Exxon Mobil Rewards+ account or log into an existing one\n* Enter your Promo Code when prompted and your points will be deposited into your Exxon Mobil Rewards+ account\n\n**Perk Details**\n* You have 90 days to select. Available while supplies last\n* Your Exxon Mobil Rewards+ points expire on 12/31/25\n\n© 2024 ExxonMobil',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/inactive_$30%20Exxon%20Mobil%20Perk_79cc78f8-ba92-4425-bcd7-1795760cca99',
            shortDescription: '',
            shortName: '',
            perkStatus: 'REDEEMED',
            perkType: 'THD_COUPONS_CMS',
            activationType: 'CMS',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'IN_STORE',
            creationTime: '02/07/2024',
            activationTime: '02/09/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 239,
            perkSourceUUID: '88c80a68-1168-44ee-9fdd-f803177275ad',
            paymentId: 'P12519B889F43D2960',
            perkDisplaySeqNumber: 1,
            amount: 5,
            availableBalance: 0,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            rewardId: '53c5ef5a-ec36-4736-b92d-59ce3a1b4e22',
            earnedAtSpend: 2500,
            tierRewardId: '3040f00b-3ed2-431f-a9aa-7134ebd9d336',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '153d3233-5135-4531-84ee-8c4d75984d6b',
        name: '2.5K-5K',
        tierNumber: 5091,
        minThreshold: 2500.01,
        maxThreshold: 5000,
        minThresholdDisplay: '2.5K',
        maxThresholdDisplay: '5K',
        earned: true,
        tierPerks: [
          {
            perkId: 'ec314f49-816e-4cd2-895c-958676327f3f',
            perkTitle: 'Pro Xtra Dollars',
            perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
            shortName: 'Pro Xtra Dollars',
            perkStatus: 'ACTIVE',
            perkType: 'GIFT_CARD',
            activationType: 'PAYMENTS',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'OMNI_CHANNEL',
            creationTime: '05/07/2024',
            activationTime: '05/20/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 331,
            perkSourceUUID: '225799c8-38b6-45c2-9bc9-539e176a0ba2',
            paymentId: 'P1453A3509C1F10200',
            perkDisplaySeqNumber: 2,
            amount: 50,
            availableBalance: 50,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: true,
            rewardId: '1e18a0df-dbc8-4cfe-93f2-84c046a003fd',
            earnedAtSpend: 5000,
            tierRewardId: '75045dac-7a3e-4ca7-a637-7d31528dbf5f',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '6e9d13ea-5447-4bec-ac43-e13ff362d930',
        name: '5K-10K',
        tierNumber: 5092,
        minThreshold: 5000.01,
        maxThreshold: 10000,
        minThresholdDisplay: '5K',
        maxThresholdDisplay: '10K',
        earned: true,
        tierPerks: [
          {
            perkId: '64be70f7-5114-4b91-9aff-83fa69374d26',
            perkTitle: 'Pro Xtra Dollars',
            perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
            shortName: 'Pro Xtra Dollars',
            perkStatus: 'ACTIVE',
            perkType: 'GIFT_CARD',
            activationType: 'PAYMENTS',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'OMNI_CHANNEL',
            creationTime: '05/07/2024',
            activationTime: '05/20/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 331,
            perkSourceUUID: '960d2679-68e5-4be2-b06f-a95d28632a03',
            paymentId: 'P1253A448818790080',
            perkDisplaySeqNumber: 3,
            amount: 50,
            availableBalance: 11.3,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: true,
            rewardId: '1e18a0df-dbc8-4cfe-93f2-84c046a003fd',
            earnedAtSpend: 10000,
            tierRewardId: '1802f257-b111-4b28-a375-218a05da521e',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      { // used in example perk Reward Barcode Drawer in local instance
        tierId: '5095b161-a5ba-41e2-8d75-d5a2f070e85d',
        name: '10K-15K',
        tierNumber: 5093,
        minThreshold: 10000.01,
        maxThreshold: 15000,
        minThresholdDisplay: '10K',
        maxThresholdDisplay: '15K',
        earned: true,
        tierPerks: [
          {
            perkId: '69c77aea-20e8-4dea-84ab-25a9466ea8b1',
            perkTitle: 'Pro Xtra Dollars',
            perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
            shortName: 'Pro Xtra Dollars',
            perkStatus: 'ACTIVE',
            perkType: 'GIFT_CARD',
            activationType: 'PAYMENTS',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'OMNI_CHANNEL',
            creationTime: '05/07/2024',
            activationTime: '05/28/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 331,
            perkSourceUUID: '59de6e4e-7e98-4d67-a725-6e04a93a993c',
            paymentId: 'P1353CDA4079FEAE20',
            perkDisplaySeqNumber: 4,
            amount: 50,
            availableBalance: 50,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: true,
            rewardId: '1e18a0df-dbc8-4cfe-93f2-84c046a003fd',
            earnedAtSpend: 15000,
            tierRewardId: '7e42ad66-97ac-408d-8cb3-956bd3469473',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '82093f03-204a-4829-ad3e-3c9985b26535',
        name: '15K-20K',
        tierNumber: 5094,
        minThreshold: 15000.01,
        maxThreshold: 20000,
        minThresholdDisplay: '15K',
        maxThresholdDisplay: '20K',
        earned: true,
        tierPerks: [
          {
            perkId: 'ad590abb-2cb5-425d-900f-e9e5c2c53781',
            perkTitle: 'Pro Xtra Dollars',
            perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
            shortName: 'Pro Xtra Dollars',
            perkStatus: 'ACTIVE',
            perkType: 'GIFT_CARD',
            activationType: 'PAYMENTS',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'OMNI_CHANNEL',
            creationTime: '05/07/2024',
            activationTime: '05/29/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 331,
            perkSourceUUID: 'f61d1b4e-0b7a-4282-9274-dcdda3bed285',
            paymentId: 'P1253D167904528440',
            perkDisplaySeqNumber: 5,
            amount: 50,
            availableBalance: 17.55,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: true,
            rewardId: '1e18a0df-dbc8-4cfe-93f2-84c046a003fd',
            earnedAtSpend: 20000,
            tierRewardId: 'd5703a77-4382-4025-b9bb-69d4993e3c9c',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: 'a485b691-c5f2-401c-9cd8-d9888181ea77',
        name: '20K-25K',
        tierNumber: 5095,
        minThreshold: 20000.01,
        maxThreshold: 25000,
        minThresholdDisplay: '20K',
        maxThresholdDisplay: '25K',
        earned: true,
        tierPerks: [
          {
            perkId: '792542bc-e703-4215-b67e-59b4bb903781',
            perkTitle: 'Pro Xtra Dollars',
            perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
            shortName: 'Pro Xtra Dollars',
            perkStatus: 'ACTIVE',
            perkType: 'GIFT_CARD',
            activationType: 'PAYMENTS',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'OMNI_CHANNEL',
            creationTime: '05/07/2024',
            activationTime: '05/29/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 331,
            perkSourceUUID: 'f754f7ba-1211-4ab0-a1a2-3db0b3a4e9f5',
            paymentId: 'P1353D22827459A180',
            perkDisplaySeqNumber: 6,
            amount: 50,
            availableBalance: 50,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: true,
            rewardId: '1e18a0df-dbc8-4cfe-93f2-84c046a003fd',
            earnedAtSpend: 25000,
            tierRewardId: '853079d5-358c-41a9-9563-644079b239da',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: 'eae53de3-dd60-4c12-8709-ef83a4e33e2d',
        name: '25K-30K',
        tierNumber: 5096,
        minThreshold: 25000.01,
        maxThreshold: 30000,
        minThresholdDisplay: '25K',
        maxThresholdDisplay: '30K',
        earned: true,
        tierPerks: [
          {
            perkId: 'ba5bd6d5-25be-4f80-9136-6578d177b677',
            perkTitle: 'Rental Perk',
            perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
            perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
            shortName: 'Rental Perk',
            perkStatus: 'ACTIVE',
            perkType: 'TOOL_RENTAL',
            activationType: 'PRICING_ENGINE',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            availability: 'IN_STORE',
            creationTime: '05/07/2024',
            activationTime: '05/29/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 331,
            perkSourceUUID: 'ff63f8ac-0567-4b3c-9e66-5d6dd4a76a41',
            paymentId: 'P1353D228C3C4429A0',
            perkDisplaySeqNumber: 7,
            amount: 125,
            availableBalance: 0,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            rewardId: '39c819c8-ddc0-4725-8a9e-fbf286bc20bc',
            earnedAtSpend: 30000,
            tierRewardId: '448d8e2a-6d19-4553-9258-dd605b7c41be',
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '3ba0110a-5ef8-4a06-af97-0af7f217b341',
        name: '30K-35K',
        tierNumber: 5097,
        minThreshold: 30000.01,
        maxThreshold: 35000,
        minThresholdDisplay: '30K',
        maxThresholdDisplay: '35K',
        earned: true,
        tierPerks: [
          {
            perkId: 'dc08b5af-7050-45b0-ab11-6a56462a2a33',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: 'fedadc2d-82be-4b82-a170-de431af18abe',
            perkDisplaySeqNumber: 8,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: 'aeb30470-5991-46e0-ad4b-35510702823f',
                amount: 50,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: 'b9408dbd-38bf-4fc5-a805-62a39a66fee6',
                amount: 140,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 35000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '101a0ee9-43ce-4cb6-8eff-973b55c6c2fa',
        name: '35K-40K',
        tierNumber: 5098,
        minThreshold: 35000.01,
        maxThreshold: 40000,
        minThresholdDisplay: '35K',
        maxThresholdDisplay: '40K',
        earned: true,
        tierPerks: [
          {
            perkId: '7d5d1d85-0ccd-4ef5-9023-d12c100a38d3',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '92642187-bf26-4094-a736-b16d170a6589',
            perkDisplaySeqNumber: 9,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: 'e2bc0d4b-88f4-4524-9a6e-8090a5c7afab',
                amount: 50,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '271be47f-5bb7-4a40-948b-b7d3ed89951e',
                amount: 140,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 40000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '61f7e7bb-7891-40bf-b06c-1dbf254e029d',
        name: '40K-45K',
        tierNumber: 5099,
        minThreshold: 40000.01,
        maxThreshold: 45000,
        minThresholdDisplay: '40K',
        maxThresholdDisplay: '45K',
        earned: true,
        tierPerks: [
          {
            perkId: '1046278b-3706-451e-8419-76216ab6ba40',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '34c12d7a-c2a0-4b48-a2db-85231a7a6276',
            perkDisplaySeqNumber: 10,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: 'd6f50e63-c778-4521-bcb1-8db92fef8e94',
                amount: 50,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '5c4c8acd-5be8-48d8-b6b8-78a08956f694',
                amount: 160,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 45000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: 'da781fa5-74e3-46b2-a520-02ca5d233207',
        name: '45K-50K',
        tierNumber: 5100,
        minThreshold: 45000.01,
        maxThreshold: 50000,
        minThresholdDisplay: '45K',
        maxThresholdDisplay: '50K',
        earned: true,
        tierPerks: [
          {
            perkId: 'ebc5d87d-86ed-43fc-98e5-3e53e2bb5d05',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: 'b9b86740-acc3-4711-bbc0-1066a1445221',
            perkDisplaySeqNumber: 11,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '92225cd9-cd00-4123-a904-45fea2dfbe90',
                amount: 50,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '9ee87b7b-5325-4268-8718-c3012ee42042',
                amount: 175,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 50000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '135d6306-e7a8-4bbd-8362-5039bc98e45c',
        name: '50K-60K',
        tierNumber: 5101,
        minThreshold: 50000.01,
        maxThreshold: 60000,
        minThresholdDisplay: '50K',
        maxThresholdDisplay: '60K',
        earned: true,
        tierPerks: [
          {
            perkId: '77f1a257-20f2-4885-bb5e-db600cff60f8',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '8e801abd-7caf-4063-ae2b-bf754f8521a0',
            perkDisplaySeqNumber: 12,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '8d7aa236-f027-40fd-b436-ac63ae6b5b70',
                amount: 70,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '4ce31cd3-6f35-4f40-8d10-333744a6fb6a',
                amount: 175,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 60000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '6d34eea6-d67a-4e40-9600-b51d26ef7c71',
        name: '60K-70K',
        tierNumber: 5102,
        minThreshold: 60000.01,
        maxThreshold: 70000,
        minThresholdDisplay: '60K',
        maxThresholdDisplay: '70K',
        earned: true,
        tierPerks: [
          {
            perkId: '732f2e33-8f25-49a3-9f61-6bf1cb2d233b',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: 'd98f262c-2e81-43fd-ab2a-e3890ee810d1',
            perkDisplaySeqNumber: 13,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '9e9316aa-4924-458f-872c-0c1db0e35bd5',
                amount: 70,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '54f9717d-6133-400a-a61c-8573083e6644',
                amount: 225,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 70000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: 'eee3f0c0-ee82-424c-b0c0-e46bcd6d5fbe',
        name: '70K-80K',
        tierNumber: 5103,
        minThreshold: 70000.01,
        maxThreshold: 80000,
        minThresholdDisplay: '70K',
        maxThresholdDisplay: '80K',
        earned: true,
        tierPerks: [
          {
            perkId: 'a06af3e2-3aac-4972-8c3c-472c0122b028',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '8b889424-5f85-4618-bf8b-6a21f6615756',
            perkDisplaySeqNumber: 14,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '3dd105a2-7d65-4391-be39-a9fe4afee3bd',
                amount: 70,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '09af15bb-0589-4e13-be7a-80ea204249a4',
                amount: 275,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 80000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '37f449db-ae57-41dc-a1a8-4d0150eb9582',
        name: '80K-90K',
        tierNumber: 5104,
        minThreshold: 80000.01,
        maxThreshold: 90000,
        minThresholdDisplay: '80K',
        maxThresholdDisplay: '90K',
        earned: true,
        tierPerks: [
          {
            perkId: '0290b9c8-032f-4a36-9836-febfa6215036',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: 'f202ed03-5e08-43b9-b454-4750a3b7e739',
            perkDisplaySeqNumber: 15,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: 'a7cbfa21-36a4-4fe9-9a34-39187e1a2bb2',
                amount: 70,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '040fefcc-1189-4842-b6e9-643028593a43',
                amount: 300,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 90000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '66c3df27-60d4-42dc-8fe3-9fca5283f8da',
        name: '90K-100K',
        tierNumber: 5105,
        minThreshold: 90000.01,
        maxThreshold: 100000,
        minThresholdDisplay: '90K',
        maxThresholdDisplay: '100K',
        earned: true,
        tierPerks: [
          {
            perkId: 'c2eab64b-112c-4816-aad5-c650c429b942',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '1e9bddbe-bc82-4721-aedd-2e5a1b8f8621',
            perkDisplaySeqNumber: 16,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '979177cd-861e-4927-9e8d-df819c3b0770',
                amount: 100,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: 'afeece18-d400-465c-a149-5862837a35ae',
                amount: 350,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 100000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '7d3f2b98-bf05-472a-a698-0fc286f238f1',
        name: '100K-125K',
        tierNumber: 5955,
        minThreshold: 100000.01,
        maxThreshold: 125000,
        minThresholdDisplay: '100K',
        maxThresholdDisplay: '125K',
        earned: true,
        tierPerks: [
          {
            perkId: '4d74ec9d-e749-4f19-95aa-cffdb772903f',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '0f733783-a7f4-4c27-adfe-c20e0b46407f',
            perkDisplaySeqNumber: 17,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '6c3495ea-2d0a-4b77-bf15-0e5b4258903a',
                amount: 100,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '30ea9b43-6d1c-41f5-838d-222d2d28ca0d',
                amount: 350,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 125000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '89e9b8cc-6518-4f26-ad51-f7148f875def',
        name: '125K-150K',
        tierNumber: 5956,
        minThreshold: 125000.01,
        maxThreshold: 150000,
        minThresholdDisplay: '125K',
        maxThresholdDisplay: '150K',
        earned: true,
        tierPerks: [
          {
            perkId: '3b15bd42-59de-4805-8235-b1d670b75a8e',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '83d42c2b-c7d8-4c92-b432-0a59ef352c0b',
            perkDisplaySeqNumber: 18,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '7f5e95b1-a3dd-4c86-82da-4643310fea54',
                amount: 100,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: 'e15b4297-bee9-48b0-b7b3-2633afd1d0f3',
                amount: 350,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 150000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '68fc02d3-9434-4381-8f97-83c282108d51',
        name: '150K-200K',
        tierNumber: 5957,
        minThreshold: 150000.01,
        maxThreshold: 200000,
        minThresholdDisplay: '150K',
        maxThresholdDisplay: '200K',
        earned: true,
        tierPerks: [
          {
            perkId: 'e9f21616-a6ce-49d1-adc6-fa4765d719ab',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '0c2de7a8-73dd-4a8c-9c5b-d73da557137d',
            perkDisplaySeqNumber: 19,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '16728e95-55bb-4059-aa34-38913a992aab',
                amount: 150,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: 'bc97359f-b88d-47f1-a363-5f421b07b435',
                amount: 350,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 200000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: 'f9910dff-e66c-4e65-9d74-56f7f7fd2375',
        name: '200K-250K',
        tierNumber: 5958,
        minThreshold: 200000.01,
        maxThreshold: 250000,
        minThresholdDisplay: '200K',
        maxThresholdDisplay: '250K',
        earned: true,
        tierPerks: [
          {
            perkId: 'df22b334-e381-45bf-9faa-56077c523f10',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '279b9d90-89f0-4783-98bf-8b1778a198f1',
            perkDisplaySeqNumber: 20,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: 'e80fdef7-5dc7-444f-bf04-a299f276c026',
                amount: 150,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '193ccddc-a3f6-4fd6-9cc1-9a3f40580398',
                amount: 350,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 250000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '6d126ddb-6048-437a-a9fa-73c7e1337bb5',
        name: '250K-300K',
        tierNumber: 5959,
        minThreshold: 250000.01,
        maxThreshold: 300000,
        minThresholdDisplay: '250K',
        maxThresholdDisplay: '300K',
        earned: true,
        tierPerks: [
          {
            perkId: 'ff374c4f-9d96-4fb2-a41b-b7528a867d66',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '2732c6a5-1a5a-4bad-8fb0-663345c674fb',
            perkDisplaySeqNumber: 21,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '0d957421-49a1-4882-9a7a-8f08079ef78b',
                amount: 150,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '876a0a33-d573-4fa9-85e0-10871d80dba0',
                amount: 375,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 300000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '0d636fbf-3e5c-41b0-a0db-c20c25fc7fe2',
        name: '300K-400K',
        tierNumber: 5960,
        minThreshold: 300000.01,
        maxThreshold: 400000,
        minThresholdDisplay: '300K',
        maxThresholdDisplay: '400K',
        earned: true,
        tierPerks: [
          {
            perkId: '20e3532e-6f6a-41c9-b5c0-403d71a47a49',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: 'a807d2e9-f55f-4512-8531-c1ac41c1a0df',
            perkDisplaySeqNumber: 22,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '92e9d99d-2fc4-4a12-a79f-432b3c89fa2b',
                amount: 200,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '6ae1745c-a91d-4dcc-a9b8-3afe14371b4d',
                amount: 375,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 400000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '1c447dc1-d589-40eb-80c8-a1b38d2c74b3',
        name: '400K-500K',
        tierNumber: 5961,
        minThreshold: 400000.01,
        maxThreshold: 500000,
        minThresholdDisplay: '400K',
        maxThresholdDisplay: '500K',
        earned: true,
        tierPerks: [
          {
            perkId: 'c810c93c-9d61-44da-bd31-864e79b026ab',
            perkStatus: 'UNCLAIMED',
            triggerType: 'ACCRUAL_RETIER',
            offerType: 'PERK',
            creationTime: '05/07/2024',
            expirationTime: getFormattedDaysFromToday(90),
            yearEarned: 2024,
            daysLeft: 31,
            perkSourceUUID: '0237d8a4-a759-462a-9ca4-dbb7f093e996',
            perkDisplaySeqNumber: 23,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '5d971be4-15f2-4865-843b-1957d63485a4',
                amount: 200,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: 'e5d24477-c2a9-40c8-b587-bf63d4a2ec7f',
                amount: 450,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 500000,
            earned: true
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 100
      },
      {
        tierId: '35c8d2a6-28ff-40c4-b34e-b950f7ef4e66',
        name: '500K-600K',
        tierNumber: 5962,
        minThreshold: 500000.01,
        maxThreshold: 600000,
        minThresholdDisplay: '500K',
        maxThresholdDisplay: '600K',
        earned: false,
        tierPerks: [
          {
            yearEarned: 0,
            perkDisplaySeqNumber: 24,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '54047f20-5899-44ba-b446-edfcae6ad01a',
                amount: 200,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '9e6b0755-33c7-4993-b1b5-e0cad8886335',
                amount: 500,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 600000,
            earned: false
          }
        ],
        currentTier: true,
        spendForNextTier: 599934.28,
        progressPercentage: 0
      },
      {
        tierId: '1709a6d5-22cd-4526-b0e0-dd523702fcb5',
        name: '600K-700K',
        tierNumber: 5963,
        minThreshold: 600000.01,
        maxThreshold: 700000,
        minThresholdDisplay: '600K',
        maxThresholdDisplay: '700K',
        earned: false,
        tierPerks: [
          {
            yearEarned: 0,
            perkDisplaySeqNumber: 25,
            amount: 0,
            availableBalance: 0,
            options: [
              {
                perkType: 'GIFT_CARD',
                activationType: 'PAYMENTS',
                triggerType: 'DIGITAL_REWARDS_CARDS',
                availability: 'OMNI_CHANNEL',
                tierRewardId: '077d9251-92e9-4949-bc9b-b50e38eae8d1',
                amount: 200,
                perkTitle: 'Pro Xtra Dollars',
                perkDescription: '**Important details about your Pro Xtra Dollars:**\n* Pro Xtra Dollars are Home Depot Digital Reward Cards.\n* Expires 12 months after selection.\n* May be used to purchase merchandise/services at Home Depot stores in U.S. and Canada and online at HomeDepot.com.\n* Can be redeemed in-store or online during checkout.\n* Not redeemable for cash or credit unless required by law.\n* See [Pro Xtra Terms and Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for additional details.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-PXDollars_653ca682-5b46-4b2d-8b19-24d397a363de.png',
                shortName: 'Pro Xtra Dollars',
                sequenceNumber: 0,
                giftCard: true
              },
              {
                perkType: 'TOOL_RENTAL',
                activationType: 'PRICING_ENGINE',
                triggerType: 'THD_COUPONS',
                availability: 'IN_STORE',
                tierRewardId: '74de3fca-0269-4761-ac6f-c20f6e4db8d3',
                amount: 500,
                perkTitle: 'Rental Perk',
                perkDescription: '**Important details about your Rental Perk:**\n*  Redeemable for rental charges for eligible tools and equipment at [The Home Depot Rental Centers](https://www.homedepot.com/c/tool_and_truck_rental) in the U.S. \n*  Expires 12 months after selection.\n* To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.\n* One Perk per rental contract.\n*  A Perk may be used once, not redeemable for cash or credit.\n*  See [Pro Xtra Terms & Conditions](https://www.homedepot.com/c/ProXtra_TermsandConditions) for exclusions and additional information.',
                perkImageUrl: 'https://storage.googleapis.com/storage.hd-loyalty-prod.gcp.homedepot.com/RewardImages/active_Legacy-ToolRental_ca2697a9-c62c-43b0-8834-cb1ebfa67cb5.png',
                shortName: 'Rental Perk',
                sequenceNumber: 1,
                giftCard: false
              }
            ],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 700000,
            earned: false
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 0
      },
      {
        tierId: '56c7a7c7-afce-43b0-9727-48abdf76849a',
        name: '700K-800K',
        tierNumber: 5964,
        minThreshold: 700000.01,
        maxThreshold: 800000,
        minThresholdDisplay: '700K',
        maxThresholdDisplay: '800K',
        earned: false,
        tierPerks: [
          {
            yearEarned: 0,
            perkDisplaySeqNumber: 26,
            amount: 0,
            availableBalance: 0,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 800000,
            earned: false
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 0
      },
      {
        tierId: 'ecce80ce-5c6e-45e0-ba41-11c9e216b33a',
        name: '800K-900K',
        tierNumber: 5965,
        minThreshold: 800000.01,
        maxThreshold: 900000,
        minThresholdDisplay: '800K',
        maxThresholdDisplay: '900K',
        earned: false,
        tierPerks: [
          {
            yearEarned: 0,
            perkDisplaySeqNumber: 27,
            amount: 0,
            availableBalance: 0,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 900000,
            earned: false
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 0
      },
      {
        tierId: 'bae668a4-1cfc-4c62-9dd6-1e4818763535',
        name: '900K-1M',
        tierNumber: 5966,
        minThreshold: 900000.01,
        maxThreshold: 1000000,
        minThresholdDisplay: '900K',
        maxThresholdDisplay: '1M',
        earned: false,
        tierPerks: [
          {
            yearEarned: 0,
            perkDisplaySeqNumber: 28,
            amount: 0,
            availableBalance: 0,
            options: [],
            renewed: false,
            exchanged: false,
            adminIssued: false,
            bulkIssued: false,
            bonusPerk: false,
            giftCard: false,
            earnedAtSpend: 1000000,
            earned: false
          }
        ],
        currentTier: false,
        spendForNextTier: 0,
        progressPercentage: 0
      }
    ]
  },
  nonProgramPerks: [],
  previousYearPerks: []
};
